import { Alert, Box, Skeleton, Stack } from '@cmg/design-system';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import InvestorSearch from '../../../order-book/components/InvestorSearch';
import { SidePanelTitle } from '../../components/side-bar/components/design-system';
import { useCmgEntityKeyContext } from '../../contexts/CmgEntityKeyContext';
import { useOfferingSidePanelOfferingId } from '../../hooks/useOfferingSidePanelMatch';
import { OfferingSidePanelRouteContext } from '../../OfferingSidePanelContainer';
import offeringSidePanelSellSideRouteFactory from '../../offeringSidePanelSellSideRouteFactory';
import { useNotes_IndicationInvestorQuery } from './graphql';
import Notes from './Notes';

const NotesRoute: React.FC = () => {
  const { cmgEntityKey } = useCmgEntityKeyContext();
  const baseSidePanelUrl = React.useContext(OfferingSidePanelRouteContext);
  const navigate = useNavigate();
  const offeringId = useOfferingSidePanelOfferingId();

  const {
    data: indicationsData,
    loading: indicationsLoading,
    error: indicationsError,
  } = useNotes_IndicationInvestorQuery({ variables: { offeringId } });

  const indications =
    indicationsData?.basicPublishedOffering?.orderBook.institutionalIndications ?? [];
  const currentIndication = indications.find(
    i => i.investorInformation.cmgEntityKey === cmgEntityKey
  );

  if (indicationsLoading) {
    return (
      <Stack role="progressbar" gap={1}>
        <Skeleton sx={{ height: theme => theme.spacing(4) }} width="20%" />
        <Skeleton sx={{ height: theme => theme.spacing(4) }} variant="rectangular" width="100%" />
        <Skeleton sx={{ height: theme => theme.spacing(4) }} variant="rectangular" width="100%" />
        <Skeleton sx={{ height: theme => theme.spacing(2) }} variant="rectangular" width="20%" />
        <Skeleton sx={{ height: theme => theme.spacing(3) }} variant="rectangular" width="30%" />
        <Skeleton sx={{ height: theme => theme.spacing(6) }} variant="rectangular" width="100%" />
        <Skeleton sx={{ height: theme => theme.spacing(6) }} variant="rectangular" width="100%" />
      </Stack>
    );
  }
  if (indicationsError) {
    return <Alert severity="error">{indicationsError.message}</Alert>;
  }

  return (
    <div>
      <SidePanelTitle>Notes</SidePanelTitle>
      <Stack direction="row" justifyContent="center" alignItems="center">
        <Box data-testid="investor-search" width={502}>
          <InvestorSearch
            investors={indications.map(ds => {
              return {
                key: ds.investorInformation.cmgEntityKey!,
                name:
                  ds.investorInformation.bankInvestorName ?? ds.investorInformation.cmgEntityName!,
              };
            })}
            onChange={key => {
              if (key) {
                navigate(
                  baseSidePanelUrl +
                    offeringSidePanelSellSideRouteFactory.orderBookNotes.getUrlPath({
                      cmgEntityKey: key,
                    })
                );
              }
            }}
            currentKey={cmgEntityKey!}
            placehorder="Select an Investor"
          />
        </Box>
      </Stack>

      {currentIndication && (
        <Notes offeringId={offeringId} indicationId={currentIndication.id}></Notes>
      )}
    </div>
  );
};

export default NotesRoute;
